import { useEffect, useRef } from 'react'
import { useKeyPress } from '../../../../shared'
import { useHelpVisibility } from '../../help'
import { useTogglePanel } from '../../panels'

/**
 * TODO: keyboard shortcuts
 * @param {*} props
 */
const SedaShortcuts = () => {
  const togglePanel = useRef()
  togglePanel.current = useTogglePanel()
  // help panel shortcut
  const helpPress = useKeyPress('?')
  const toggleHelp = useRef()
  toggleHelp.current = useHelpVisibility()[1]
  useEffect(() => {
    helpPress && toggleHelp.current()
  }, [helpPress])
  // metric panel shortcut
  const metricPress = useKeyPress('m')
  useEffect(() => {
    metricPress && togglePanel.current('metric')
  }, [metricPress])
  // region panel shortcut
  const regionPress = useKeyPress('r')
  useEffect(() => {
    regionPress && togglePanel.current('region')
  }, [regionPress])
  // subgroup panel shortcut
  const subgroupPress = useKeyPress('g')
  useEffect(() => {
    subgroupPress && togglePanel.current('demographic')
  }, [subgroupPress])
  // filter panel shortcut
  const filterPress = useKeyPress('f')
  useEffect(() => {
    filterPress && togglePanel.current('filter')
  }, [filterPress])
  // location list panel shortcut
  const locationPress = useKeyPress('l')
  useEffect(() => {
    locationPress && togglePanel.current('location')
  }, [locationPress])
  return null
}

SedaShortcuts.propTypes = {}

export default SedaShortcuts
